const welcomeTheme = {
  boxToHoldEverything: {
    marginTop: 10,
    width: '100%',
    height: '98%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  boundryBox: {
    width: '98%',
    borderRadius: 10,
    backgroundColor: '#EEEEEE',
    height: 'inherit',
    overflow: 'auto',
  },

  boxToHoldAllCards: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },

  cardBox: {
    height: 150,
    width: '45%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    margin: 10,
    borderRadius: 10,
  },

  cardBoxHover: {
    height: 150,
    width: '45%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    cursor: 'pointer',
    margin: 10,
    borderRadius: 10,
    border: '1px solid grey',
  },

  plansRankCardBox: {
    height: 150,
    width: '45%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    margin: 10,
    borderRadius: 10,
    cursor: 'pointer',
  },

  plansRankCardBoxHover: {
    height: 150,
    width: '45%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid grey',
    margin: 10,
    borderRadius: 10,
    cursor: 'pointer',
  },

  noPlansCardBox: {
    height: 150,
    width: '45%',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '18px',
    margin: 10,
    borderRadius: 10,
  },
  cardBoxTransparent: {
    height: 150,
    width: '45%',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'row',
    margin: 10,
    borderRadius: 10,
  },

  cardBox20: {
    width: '20%',
    height: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  boxToHoldIcon: {
    borderRadius: 30,
    backgroundColor: '#EEEEEE',
    width: 50,
    height: 50,
    display: 'flex',

    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  boxToHoldIconTransparent: {
    borderRadius: 30,
    backgroundColor: 'transparent',
    width: 50,
    height: 50,
    display: 'flex',

    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },

  iconProperties: {
    width: 30,
    height: 30,
  },

  cardBox80: {
    width: '80%',
    height: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  boxToHoldContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },

  boxToHoldNumber: {
    fontSize: 40,
    paddingLeft: 10,
    marginBottom: 5,
  },

  boxToHoldText: {
    marginTop: 5,
    paddingLeft: 12,
    fontSize: '16px',
  },

  boxToHoldPlansRank: {
    border: '1px soldi red',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
};

export default welcomeTheme;
